module.exports = __webpack_public_path__ + "static/media/building_1.50caf930.jpg";